import script from "./SliderVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderVerify.vue?vue&type=script&setup=true&lang=js"

import "@/shared/styles/SliderVerify.css?vue&type=style&index=0&id=f87bfe4c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f87bfe4c"]])

export default __exports__